<div class="modal">
    <div class="modal-content">
        <div class="modal-body">
            <div class="loading-txt">{{ message }}</div>
            <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
    </div>
</div>
<div class="modal-background"></div>